"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDevice = void 0;
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'MobileDevice';
class MobileDevice extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, { ...ob, type: ob.type ?? typeName });
        this.mobilePushPlatform = ob.mobilePushPlatform;
        this.deviceToken = ob.deviceToken;
        this.platformEndpointArn = ob.platformEndpointArn;
        this.isProduction = !!ob.isProduction;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.MobileDevice = MobileDevice;
